(function () {
  function initPortfolio(zone) {
    if (!zone || zone.dataset.acPortfolioReady === 'true') return;
    zone.dataset.acPortfolioReady = 'true';

    const modal = zone.querySelector('#ac-grid-inquiry-modal');
    let lastFocused = null;
    let focusFrame = null;
    let previousOverflow = '';
    let hadRfqOpen = false;
    if (modal) modal.tabIndex = -1;

    function visibleCount() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        return Number(zone.dataset.mobileCount || 4);
      }
      if (window.matchMedia('(max-width: 1100px)').matches) {
        return Number(zone.dataset.tabletCount || 4);
      }
      return Number(zone.dataset.desktopCount || 4);
    }

    function syncCardCount() {
      const count = visibleCount();
      zone.querySelectorAll('.ac-row').forEach((row) => {
        row.querySelectorAll('.ac-card').forEach((card, index) => {
          card.hidden = index >= count;
        });
      });
    }

    function activateTab(button) {
      const targetId = button.dataset.acTabTarget;
      if (!targetId) return;
      zone.querySelectorAll('.ac-row').forEach((row) => {
        const active = row.id === targetId;
        row.classList.toggle('active', active);
        row.hidden = !active;
      });
      zone.querySelectorAll('.ac-tab-btn').forEach((tab) => {
        const active = tab === button;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      button.focus({ preventScroll: true });
    }

    function focusableElements() {
      return Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
        .filter((element) => !element.disabled && element.tabIndex >= 0 &&
          element.getClientRects().length && window.getComputedStyle(element).visibility === 'visible');
    }

    function focusModal() {
      (focusableElements()[0] || modal).focus({ preventScroll: true });
    }

    function openModal() {
      if (!modal || modal.classList.contains('is-visible')) return;
      const focusedBeforeSwitch = document.activeElement;
      const globalModal = document.getElementById('AaronsGlobalRFQ');
      if (globalModal && globalModal.classList.contains('is-open')) {
        const globalClose = globalModal.querySelector('button[data-aarons-rfq-close]');
        if (globalClose) globalClose.click();
      }
      lastFocused = globalModal && globalModal.contains(focusedBeforeSwitch) ? document.activeElement : focusedBeforeSwitch;
      if (globalModal && globalModal.contains(lastFocused)) lastFocused = zone.querySelector('[data-ac-open-modal]');
      previousOverflow = document.body.style.overflow;
      hadRfqOpen = document.body.classList.contains('aarons-rfq-open');
      modal.classList.add('is-visible');
      document.body.classList.add('aarons-rfq-open');
      document.body.style.overflow = 'hidden';
      focusFrame = window.requestAnimationFrame(function focusWhenVisible() {
        focusFrame = null;
        if (!modal.isConnected || !modal.classList.contains('is-visible')) return;
        if (window.getComputedStyle(modal).visibility !== 'visible' || !modal.getClientRects().length) {
          focusFrame = window.requestAnimationFrame(focusWhenVisible);
          return;
        }
        if (modal.contains(document.activeElement)) return;
        focusModal();
      });
    }

    function closeModal() {
      if (!modal || !modal.classList.contains('is-visible')) return;
      if (focusFrame !== null) window.cancelAnimationFrame(focusFrame);
      focusFrame = null;
      modal.classList.remove('is-visible');
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = previousOverflow;
      if (!hadRfqOpen) document.body.classList.remove('aarons-rfq-open');
      if (lastFocused && lastFocused.isConnected && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
      }
    }

    window.openACGridInquiryModal = openModal;
    window.closeACGridInquiryModal = closeModal;

    zone.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-ac-tab-target]');
      if (tab) {
        activateTab(tab);
        return;
      }
      if (event.target.closest('[data-ac-open-modal]')) {
        openModal();
        return;
      }
      if (event.target.closest('[data-ac-close-modal]') || event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || !modal.classList.contains('is-visible')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (!first) {
        event.preventDefault();
        modal.focus({ preventScroll: true });
      } else if (active === modal || !modal.contains(active) ||
        (event.shiftKey ? active === first : active === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    });

    document.addEventListener('focusin', (event) => {
      if (modal && modal.classList.contains('is-visible') && !modal.contains(event.target) &&
        window.getComputedStyle(modal).visibility === 'visible') {
        focusModal();
      }
    });

    zone.addEventListener('keydown', (event) => {
      const active = document.activeElement;
      if (!active || !active.matches('[data-ac-tab-target]')) return;
      const tabs = Array.from(zone.querySelectorAll('[data-ac-tab-target]'));
      const index = tabs.indexOf(active);
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        activateTab(tabs[(index + 1) % tabs.length]);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        activateTab(tabs[(index - 1 + tabs.length) % tabs.length]);
      }
    });

    const mediaQueries = [
      window.matchMedia('(max-width: 768px)'),
      window.matchMedia('(max-width: 1100px)')
    ];
    mediaQueries.forEach((media) => {
      if (media.addEventListener) media.addEventListener('change', syncCardCount);
    });
    syncCardCount();
    if (modal && modal.dataset.acOpenOnLoad === 'true' && window.location.hash === '#ACGridInquiryForm') openModal();
  }

  function start() {
    initPortfolio(document.getElementById('ac-nuclear-zone'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
